import { render, staticRenderFns } from "./addOrEditCreditNews.vue?vue&type=template&id=124b6de0&"
import script from "./addOrEditCreditNews.vue?vue&type=script&lang=js&"
export * from "./addOrEditCreditNews.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditCreditNews.vue?vue&type=style&index=0&id=124b6de0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports